import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { useEffect } from "react";

const Master = () => {
  const location = useLocation();

  // useEffect(() => {
  //   if (!location.pathname.startsWith("/dashboard")) {
  //     localStorage.removeItem("dashboardTab");
  //   }
  // }, [location.pathname]);
  return (
    <>
      <main>
        <Header />
        <Outlet />
        <Footer />
      </main>
    </>
  );
};
export default Master;
